import { type PropsWithChildren, useMemo } from 'react'

import { type DatadogConfig, ThirdParty, type ThirdPartyConfig } from '@dhl/third-party'

import { getConfig } from '~/config'

const urlsExcludedFromLogs: string[] = []

export const StartUp = ({ children }: PropsWithChildren) => {
  const {
    cspNonce,
    datadog,
    environment,
    gtm,
    oneTrust,
    version,
    adobe: { url: adobeTagManagerUrl },
  } = getConfig()

  const config: ThirdPartyConfig = {
    oneTrustId: oneTrust.id,
    gmtId: gtm.id,
    virtualPageRootPath: 'home',
    nonce: cspNonce,
    adobeTagManagerUrl,
  }

  const datadogConfig: DatadogConfig = useMemo(
    () => ({
      ...datadog,
      environment,
      ignoreLogsErrors: [(event) => urlsExcludedFromLogs.some((url) => !!event.http?.url?.includes(url))],
      version,
    }),
    [datadog, environment, version]
  )

  return (
    <ThirdParty config={config} datadogConfig={datadogConfig}>
      {children}
    </ThirdParty>
  )
}
